import * as React from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  type: "text" | "email" | "password" | "number";
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <div className="input-wrapper" style={{ position: "relative" }}>
        <input
          type={type === "password" && showPassword ? "text" : type}
          className={"form-control"}
          ref={ref}
          {...props}
        />
        {type === "password" && (
          <button
            type="button"
            className="toggle-password"
            onClick={togglePasswordVisibility}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              color: "#777",
            }}
          >
            {showPassword ? (
              <i className="fa fa-eye" />
            ) : (
              <i className="fa fa-eye-slash" />
            )}
          </button>
        )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
